module.exports = __webpack_public_path__ + "static/media/S (101).594be99e.jpg";